import { MyFC } from '@/types/common';
import { IPageHeaderProps } from './types';

export const PageHeader: MyFC<IPageHeaderProps> = ({ children, text }) => {
  return (
    <header className="md-page-header px-[48px] sm-page-padding gap-x-[20px] flex items-center">
      <h1 className="page-title-text text-black">{text}</h1>
      {children}
    </header>
  );
};
